import { ApiConstant, AppConstant, EnvConstant } from "@/const";
import { enqueueSnackbar } from "notistack";
import { uploadFileServices } from "@/services";
import {
  CategoryTypeUploadEnum,
  IDataResponseModel,
  IUploadFile,
} from "@/models";
const useHandleUploadImage = () => {
  const handleUploadImage = async (
    fileArr: Array<File>,
    categoryType: CategoryTypeUploadEnum,
    ownerId: string
  ): Promise<IUploadFile[]> => {
    ownerId = ownerId || "";
    try {
      const formData: FormData = new FormData();
      for (let file of fileArr) {
        formData.append("file", file);
      }
      const response: IDataResponseModel<IUploadFile> =
        await uploadFileServices.uploadFile(formData, categoryType, ownerId);
      const responseData = response.payload;
      if (response.status !== ApiConstant.STT_OK) {
        // enqueueSnackbar({
        //   variant: AppConstant.ERROR_VARIANT,
        //   message: responseData.message || "Đã có lỗi xảy ra!",
        // });
        return [];
      } else {
        enqueueSnackbar({
          variant: AppConstant.SUCCEED_VARIANT,
          message: "Tải ảnh thành công!",
        });
        return [responseData.data];
      }
    } catch (error) {
      EnvConstant.IS_DEV && console.log(error);
      // enqueueSnackbar({
      //   variant: AppConstant.ERROR_VARIANT,
      //   message: "Đã có lỗi xảy ra!",
      // });
      return [];
    }
  };
  return handleUploadImage;
};

export default useHandleUploadImage;
